import React from 'react';
import { Box } from '@mui/material';
import BounceLoader from 'react-spinners/BounceLoader';

const LoadingState = ({ currentColor }) => {
  const override = {
    display: 'block',
    margin: 'auto',
    borderColor: currentColor.primary,
  };

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <BounceLoader
        color={currentColor.primary}
        loading={true}
        cssOverride={override}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Box>
  );
};

export default LoadingState;
